import { States } from '@urbanx/agx.activities.client';


export const AvailableStatesForTasks = [
  States.QLD,
  States.NSW,
];
